import styled from 'styled-components';

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 30px;
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 20px;
`;
